import axios from "axios";
import React, { useEffect, useState } from "react";
import Menu from "./Navbar";
import Footer from "./Footer";

import { Link } from "react-scroll";
import Spinner from "../components/Spinner";
import SpinnerSmall from "../components/SpinnerSmall";
import dict from "../utils/dictionary";
// import skins from '../../public/skins.json';
import { Helmet } from "react-helmet";

const Skins = () => {
  const dictionary = dict()["skins"];

  const products = {
    las: [
      {
        country: "arg",
        idVerbose: "las_skin_arg",
        title: "Unranked con Skin Específica",
        name: "Unranked con Skin Específica",
        type: "skin-unranked",
        price: 0,
        originalPrice: 0,
        region: "las",
        capsuleType: "be",
        description: ["Al menos nivel 30", "MMR virgen", "0% posibilidad de ban", "Email sin verificar", "Garantia de por vida", "Fragmento Skin elegido"],
        startBe: 0,
        endBe: 100000,
      },
      {
        country: "cl",
        idVerbose: "las_skin_cl",
        title: "Unranked con Skin Específica",
        name: "Unranked con Skin Específica",
        type: "skin-unranked",
        price: 0,
        originalPrice: 0,
        region: "las",
        capsuleType: "be",
        description: ["Al menos nivel 30", "MMR virgen", "0% posibilidad de ban", "Email sin verificar", "Garantia de por vida", "Fragmento Skin elegido"],
        startBe: 0,
        endBe: 100000,
      },
    ],
    br: [
      {
        country: "arg",
        idVerbose: "br_skin_arg",
        title: "Unranked con Skin Específica",
        name: "Unranked con Skin Específica",
        type: "skin-unranked",
        price: 0,
        originalPrice: 0,
        region: "br",
        capsuleType: "be",
        description: ["Al menos nivel 30", "MMR virgen", "0% posibilidad de ban", "Email sin verificar", "Garantia de por vida", "Fragmento Skin elegido"],
        startBe: 0,
        endBe: 100000,
      },
      {
        country: "cl",
        idVerbose: "br_skin_cl",
        title: "Unranked con Skin Específica",
        name: "Unranked con Skin Específica",
        type: "skin-unranked",
        price: 0,
        originalPrice: 0,
        region: "br",
        capsuleType: "be",
        description: ["Al menos nivel 30", "MMR virgen", "0% posibilidad de ban", "Email sin verificar", "Garantia de por vida", "Fragmento Skin elegido"],
        startBe: 0,
        endBe: 100000,
      },
    ],
  };
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState(""); // New state for country selection
  const [selectedProduct, setSelectedProduct] = useState();
  const [originalSkins, setOriginalSkins] = useState([]);
  const [skins, setSkins] = useState([]);
  const [currentSkinGroup, setCurrentSkinGroup] = useState([]);
  const [champion, setChampion] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [steps, setSteps] = useState("1");
  const [selectedSkin, setSelectedSkin] = useState({});
  const [region, setRegion] = useState("");
  const [coupon, setCoupon] = useState("");
  const [mercadoPagoAvailable, setMercadoPagoAvailable] = useState(false);
  const [paykuAvailable, setPaykuAvailable] = useState(false);
  const [paykuPaymentUrl, setPaykuPaymentUrl] = useState("");
  const [generatingPaymentLoading, setGeneratingPaymentLoading] = useState(false);
  const [error, setError] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState({
    applied: false,
    discount: 0,
    price: 0,
  });

  useEffect(() => {
    getJSONSkins();
  }, []);

  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  const getJSONSkins = async () => {
    let skins = await axios.get("/skins.json");
    // console.log(skins);
    setSkins(skins.data[0]);
    setOriginalSkins(skins.data[0]);
  };
  const onChangeChampionSearcher = (event) => {
    if (event.target.value != "") {
      let skinsArray = {};

      Object.entries(originalSkins).forEach((skin) => {
        const regex = new RegExp(`${event.target.value.trim()}`, "gi"); // gi is case insensitive
        if (skin[0].match(regex)) {
          skinsArray = { ...skinsArray, [skin[0]]: skin[1] };
        }
      });
      setSkins(skinsArray);
    } else {
      getJSONSkins();
    }
  };

  const getStockForSkinGroup = async (skinGroup, region) => {
    setDiscountedPrice({ discount: 0, price: 0, applied: false });
    setCoupon("");
    setError("");
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json",
    };
    // Find the correct product based on region and country
    const productForCountry = products[region].find((p) => p.country === country);
    let stockRequest = await axios.post(`/api/v1/stock/skins/check`, { skinGroup, region, idVerbose: productForCountry.idVerbose }, headers);
    setCurrentSkinGroup(stockRequest.data.data);
    // setIsLoading(false); // Si dejamos esto comentado, false se va a poner solo cuando carguen las fotos,
    // Si le sacamos el comment, se displayeara todo sin que las imagenes hayan cargado
  };
  const onClickChampion = async (selectedChamp) => {
    setCoupon("");
    setError("");
    if (champion != selectedChamp) {
      setSteps(4);

      setChampion(selectedChamp);

      getStockForSkinGroup(originalSkins[selectedChamp], region);
    }
  };
  const onClickSkin = (skin) => {
    setDiscountedPrice({ discount: 0, price: 0, applied: false });
    setCoupon("");
    setError("");
    setMercadoPagoAvailable(false);
    setPaykuAvailable(false);
    setPaykuPaymentUrl("");
    setSteps(5);
    setSelectedSkin(skin);
    let newPricing = 0;
    currentSkinGroup.forEach((group) => {
      if (group.skinId === skin.skinId) {
        newPricing = group.price;
      }
    });
    // Find the correct product based on region and country
    const productForCountry = products[region].find((p) => p.country === country);
    setSelectedProduct({ ...productForCountry, originalPrice: newPricing, price: newPricing, skinId: skin.skinId, name: `Unranked - ${skin.skinName} (${region.toUpperCase()})` });
  };
  const onClickRegion = (newRegion) => {
    setCoupon("");
    setError("");
    setSteps(2);
    setChampion("");
    setRegion(newRegion);
    setCountry(""); // Reset country when changing region
  };
  const onClickCountry = (countryCode) => {
    setCountry(countryCode);
    setSteps(3);
    setChampion("");
  };

  const onLoad = () => {
    setIsLoading(false);
  };

  const onChangeEmail = (event) => {
    setEmail(event.target.value);
  };
  const onChangeCoupon = (event) => {
    setCoupon(event.target.value.toUpperCase());
  };
  const generatePreferenceMercadoPago = async () => {
    setGeneratingPaymentLoading(true);
    try {
      let headers = {
        "Content-Type": "application/json",
      };

      let stockRequest = await axios.post(`/api/v1/stock/skins/buy/mercadopago`, { ...selectedProduct, email, coupon: discountedPrice.applied ? coupon : "" }, headers);

      let stockOutcome = stockRequest.data;

      if (stockOutcome.msgCode === "PRODUCT_OUT_OF_STOCK") {
        setError(dictionary["errorNoStock"]);
      }
      if (stockOutcome.msgCode === "PAYMENT_CREATED" && stockOutcome.success) {
        setMercadoPagoAvailable(true);
        setError(""); // Clear any previous errors

        // Wait for the next render cycle to ensure the mpago-checkout div exists
        setTimeout(() => {
          const checkoutDiv = document.getElementById("mpago-checkout");
          if (checkoutDiv) {
            var script = document.createElement("script");
            script.src = `https://www.mercadopago.com.${dictionary["countryMpagoScript"]}/integrations/v1/web-payment-checkout.js`;
            script.type = "text/javascript";
            script.dataset.preferenceId = stockOutcome.data.transactionId;
            checkoutDiv.innerHTML = "";
            checkoutDiv.appendChild(script);
          }
        }, 100);
      }
    } catch (error) {
      console.error("MercadoPago Error:", error);
      setError(dictionary["errorPleaseTryAgain"]);
    }
    setGeneratingPaymentLoading(false);
  };
  const generatePreferencePayku = async () => {
    setGeneratingPaymentLoading(true);
    try {
      let headers = {
        "Content-Type": "application/json",
      };

      let stockRequest = await axios.post(`/api/v1/stock/skins/buy/payku`, { ...selectedProduct, email, coupon: discountedPrice.applied ? coupon : "" }, headers);

      let stockOutcome = stockRequest.data;

      if (stockOutcome.msgCode === "PRODUCT_OUT_OF_STOCK") {
        setError(dictionary["errorNoStock"]);
      }
      if (stockOutcome.msgCode === "PAYMENT_CREATED" && stockOutcome.success) {
        setPaykuPaymentUrl(stockOutcome.data.paymentUrl);
        setPaykuAvailable(true);
      }
    } catch (error) {
      console.error("Payku Error:", error);
      setError(dictionary["errorPleaseTryAgain"]);
    }
    setGeneratingPaymentLoading(false);
  };
  const checkCouponCode = async () => {
    // setGeneratingPaymentLoading(true);
    try {
      let headers = {
        "Content-Type": "application/json",
      };

      let couponRequest = await axios.post(`/api/v1/stock/coupon/check`, { coupon, quantity: 1, price: selectedProduct.price, product: selectedProduct }, headers);

      let couponOutcome = couponRequest.data;

      if (couponOutcome.msgCode === "INVALID_COUPON") {
        setError(dictionary["errorCouponInvalidForQuantity"]);
      }
      if (couponOutcome.msgCode === "INVALID_COUPON_EXPIRED") {
        setError(dictionary["errorCouponExpired"]);
      }
      if (couponOutcome.msgCode === "INVALID_COUPON_NOT_FOUND") {
        setError(dictionary["errorCouponDontExist"]);
      }
      if (couponOutcome.msgCode === "VALID_COUPON") {
        setSelectedProduct({ ...selectedProduct, price: couponOutcome.data.price, discount: couponOutcome.data.discount });
        setDiscountedPrice({ price: couponOutcome.data.price, discount: couponOutcome.data.discount, applied: true });
        setError("");
      }
    } catch (error) {
      setError(dictionary["errorPleaseTryAgain"]);
    }
  };

  const onClickGeneratePaymentMercadoPago = () => {
    setError("");
    localStorage.setItem("email", email);
    if (country === "cl") {
      generatePreferencePayku();
    } else {
      generatePreferenceMercadoPago();
    }
  };
  const onClickCheckCoupon = () => {
    if (coupon) {
      checkCouponCode();
    }
  };

  return (
    <>
      <Helmet>
        {" "}
        <title>{dictionary["pageTitle"]}</title>
      </Helmet>
      <div className="back-img" style={{ height: "auto", backgroundAttachment: "fixed" }}>
        <Menu isOnSkinsPage={true} />
        <section className="" style={{ height: "100%" }}>
          <div>
            <div className="skins-title " style={{ marginTop: "50px" }}>
              <div className="container">
                <div className="row">
                  <div className="col-md-12 col-sm-12 col-text-center d-align-center">
                    <h2 className="title" style={{ justifyContent: "center", display: "flex", color: "#dadada" }}>
                      <span> {dictionary["chooseYourRegion"]}</span>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className={`container ${isLoading ? "d-none" : "region-container"}`}>
              <Link href="#" className={`region-item col-3 ${region === "las" ? "region-selected" : ""}`} activeClass="active" to="choose-currency" spy={true} smooth={true} offset={-70} duration={500} onClick={() => onClickRegion("las")} style={{ color: "white", backgroundImage: `url("${process.env.PUBLIC_URL}/assets/images/las.webp")` }}>
                <span>{dictionary["regions"]["las"]}</span>
              </Link>
              <Link href="#" className={`region-item col-3 ${region === "br" ? "region-selected" : ""}`} activeClass="active" to="choose-currency" spy={true} smooth={true} offset={-70} duration={500} onClick={() => onClickRegion("br")} style={{ color: "white", backgroundImage: `url("${process.env.PUBLIC_URL}/assets/images/br.webp")` }}>
                <span>{dictionary["regions"]["br"]}</span>
              </Link>
            </div>

            {/* Currency Selector - Only show if region is selected */}
            {region && (
              <>
                <div id="choose-currency" className="skins-title " style={{ marginTop: "50px" }}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-text-center d-align-center">
                        <h2 className="title" style={{ justifyContent: "center", display: "flex", color: "#dadada" }}>
                          <span>Selecciona tu moneda</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`container ${isLoading ? "d-none" : "region-container"}`}>
                  <Link
                    href="#"
                    className={`region-item col-3 ${country === "arg" ? "region-selected" : ""}`}
                    activeClass="active"
                    to="choose-champ"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                    onClick={() => onClickCountry("arg")}
                    style={{
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "15px",
                      border: country === "arg" ? "3px solid #448cda" : "2px solid transparent",
                      boxShadow: country === "arg" ? "0 0 15px rgba(68, 140, 218, 0.5)" : "none",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <img src={`${process.env.PUBLIC_URL}/assets/images/argentina.png`} alt="Argentina Flag" style={{ width: "30px", height: "30px", objectFit: "contain" }} />
                    <span>Pesos Argentinos</span>
                  </Link>
                  <Link
                    href="#"
                    className={`region-item col-3 ${country === "cl" ? "region-selected" : ""}`}
                    activeClass="active"
                    to="choose-champ"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                    onClick={() => onClickCountry("cl")}
                    style={{
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "15px",
                      border: country === "cl" ? "3px solid #448cda" : "2px solid transparent",
                      boxShadow: country === "cl" ? "0 0 15px rgba(68, 140, 218, 0.5)" : "none",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <img src={`${process.env.PUBLIC_URL}/assets/images/chile.png`} alt="Chile Flag" style={{ width: "30px", height: "30px", objectFit: "contain" }} />
                    <span>Pesos Chilenos</span>
                  </Link>
                </div>
              </>
            )}

            {/* Champion Selection - Only show if country is selected */}
            {country && (
              <>
                <div id="choose-champ" className="skins-title " style={{ marginTop: "50px" }}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-text-center d-align-center">
                        <h2 className="title" style={{ justifyContent: "center", display: "flex", color: "#dadada" }}>
                          <span> {dictionary["selectAChampion"]}</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container" style={{ marginTop: "50px" }}>
                  <div className="champ-searcher">
                    <input maxLength={16} onChange={onChangeChampionSearcher} placeholder={` ${dictionary["placeholderChampInput"]}`}></input>
                  </div>
                  <div className="champion-container">
                    {Object.keys(skins).map((skin) => (
                      <Link href="#" key={skin} className={`champion-container-item ${champion === skin ? "champion-container-selected" : ""}`} activeClass="active" to="choose-skin" spy={true} smooth={true} offset={-100} duration={500} onClick={() => onClickChampion(skin)} style={{ color: "white" }}>
                        {skin}
                      </Link>
                    ))}
                  </div>
                </div>
              </>
            )}

            <div id="choose-skin" className="step-3">
              {steps >= 4 && (
                <>
                  <div className="skins-title">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12 col-sm-12 col-text-center d-align-center">
                          <h2 className="title" style={{ justifyContent: "center", display: "flex", color: "#dadada" }}>
                            <span>{dictionary["chooseYourSkin"]}</span>
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                    {isLoading && (
                      <div className="d-flex justify-content-center">
                        <Spinner />
                      </div>
                    )}

                    <div className="skin-container">
                      {currentSkinGroup.map((skin) => (
                        <div key={skin.skinId} style={isLoading ? { display: "none" } : { display: "flex" }}>
                          <div className={`skin-item-wrapper ${skin.isOnStock ? "skin-item-active" : "skin-item-disabled"} ${skin.skinId === selectedSkin.skinId ? "skin-item-selected" : ""}`}>
                            <div className="skin-item">
                              <div className="skin-price">
                                {" "}
                                <span>
                                  {dictionary["localCurrencySymbol"]}
                                  {skin.price}
                                </span>
                                <span className="skin-price-currency">{country === "cl" ? "pesos chilenos" : "pesos argentinos"}</span>
                              </div>
                              <img onLoad={onLoad} className="skin-img" src={`/skins/${skin.skinId}.jpg`}></img>
                              <div className="skin-title-container">
                                <span>{skin.skinName}</span>
                              </div>
                            </div>

                            <Link activeClass="active" to={"payment"} spy={true} smooth={true} offset={-150} duration={500} onClick={() => onClickSkin(skin)}>
                              <div className="buy-button">
                                <span>{skin.isOnStock ? dictionary["select"] : dictionary["noStock"]}</span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div id="payment" className="step-4">
              {steps >= 5 && (
                <>
                  <div className="skins-title">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12 col-sm-12 col-text-center d-align-center">
                          <h2 className="title" style={{ justifyContent: "center", display: "flex", color: "#dadada" }}>
                            <span>{dictionary["makeThePayment"]}</span>
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  {selectedProduct ? (
                    <div style={{ display: selectedProduct ? "flex" : "none", justifyContent: "center", marginTop: "50px" }}>
                      {!isLoading && (
                        <div className="innerpage-decor d-none d-xl-block">
                          <div className="innerpage-faq1" style={{ bottom: "1px", right: "1px", top: "auto" }}>
                            <img src={`${process.env.PUBLIC_URL}/assets/images/money.webp`} alt="poro with essence" />
                          </div>
                          <div className="innerpage-faq2">
                            <img src={`${process.env.PUBLIC_URL}/assets/images/gold.webp`} alt="gold" />
                          </div>
                        </div>
                      )}
                      <div className="payment-skin">
                        <h2 style={{ fontSize: "27px", textAlign: "center" }}>{selectedProduct.name}</h2>
                        <div style={{}}>
                          <h2 style={{ margin: "0px", fontSize: "20px" }}>
                            {dictionary["price"]}:{" "}
                            <span style={discountedPrice.applied ? { textDecoration: "line-through" } : {}}>
                              {dictionary["localCurrencySymbol"]}
                              {selectedProduct.originalPrice}
                            </span>{" "}
                            {discountedPrice.applied ? `${dictionary["localCurrencySymbol"]}${discountedPrice.price} (-${discountedPrice.discount}%)` : ""}
                          </h2>
                        </div>
                        <div className="skins-description-payment">
                          {selectedProduct.description.map((desc) => (
                            <div key={desc}>
                              <i className="fas fa-check mr-2" style={{ color: "#568a56" }}></i>
                              <span style={{ color: "#b7b7b7" }}>{desc}</span>
                            </div>
                          ))}
                        </div>

                        <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginTop: "20px" }}>
                          <h2 style={{ fontSize: "20px", padding: "0px 20px 0px 0px", margin: "0px" }}>{dictionary["coupon"]}</h2>
                          <input maxLength={16} value={coupon} placeholder={dictionary["useCouponToGetDiscount"]} onChange={onChangeCoupon} style={{ height: "min-content", width: "100%" }} disabled={mercadoPagoAvailable || paykuAvailable}></input>
                          <div onClick={onClickCheckCoupon} style={{ marginLeft: "20px", height: "min-content" }} className={`btn btn-custom theme-color ${mercadoPagoAvailable || paykuAvailable ? "btn-disabled" : ""}`}>
                            {dictionary["use"]}
                          </div>
                        </div>
                        {!mercadoPagoAvailable && !paykuAvailable && !generatingPaymentLoading && (
                          <>
                            <input placeholder={dictionary["yourEmail"]} onChange={onChangeEmail} value={email}></input>
                            <div onClick={onClickGeneratePaymentMercadoPago} className={`btn btn-custom theme-color mt-3 ${!validateEmail(email) ? "btn-disabled" : ""}`}>
                              {!validateEmail(email) ? dictionary["writeValidEmail"] : dictionary["generatePayment"]}
                            </div>
                          </>
                        )}
                        {error && (
                          <div className="error-message">
                            <i style={{ color: "#d42121" }} className="fas fa-times mr-2"></i>
                            <span>{error}</span>
                          </div>
                        )}
                        {mercadoPagoAvailable && <div id="mpago-checkout" style={{ display: "flex", justifyContent: "center" }}></div>}
                        {paykuAvailable && paykuPaymentUrl && (
                          <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                            <a href={paykuPaymentUrl} style={{ textDecoration: "none", width: "100%" }} target="_blank" rel="noopener noreferrer">
                              <div className="btn btn-custom theme-color" style={{ width: "100%" }}>
                                Pagar {dictionary["localCurrencySymbol"]}
                                {discountedPrice.applied ? discountedPrice.price : selectedProduct.originalPrice}
                              </div>
                            </a>
                          </div>
                        )}
                        {generatingPaymentLoading && (
                          <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <SpinnerSmall />
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <Spinner />
                  )}

                  {/* )} */}
                </>
              )}
            </div>
          </div>
        </section>
      </div>
      <div className="skins-title">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-text-center d-align-center"></div>
          </div>
        </div>
      </div>
      <Footer secondDisclaimer={true} />
    </>
  );
};

export default Skins;
